module.exports = __webpack_public_path__ + "static/media/night4.b7c17652.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night4.jpeg
// module id = 27
// module chunks = 0